import api from './api'
export interface NewsletterPreference {
  newsletter_subscribed: boolean | null
  newsletter_decided_at: string | null
  newsletter_consent_version: string | null
  needs_newsletter_prompt: boolean
}
export interface SignupMetadata {
  newsletter_subscribed?: boolean
  signup_source?: string
  signup_medium?: string
  signup_campaign?: string
  signup_referrer_host?: string
  turnstile_token?: string
}
export const marketingService = {
  async getNewsletter(): Promise<NewsletterPreference> {
    const response = await api.get('/auth/newsletter'); return response.data.data
  },
  async setNewsletter(subscribed: boolean, origin: 'dashboard_prompt' | 'account_settings'): Promise<NewsletterPreference> {
    const response = await api.put('/auth/newsletter', { newsletter_subscribed: subscribed, origin }); return response.data.data
  },
}
